import {
  PullToRefresh as SharedPullToRefresh,
  type PullToRefreshProps as SharedPullToRefreshProps,
} from '@/components/pull-to-refresh'

type Props = Omit<
  SharedPullToRefreshProps,
  'testId' | 'pullLabelKey' | 'releaseLabelKey' | 'refreshingLabelKey'
>

export function NotificationsPullToRefresh(props: Props) {
  return (
    <SharedPullToRefresh
      {...props}
      testId="notifications-pull-to-refresh"
      pullLabelKey="notifications.refresh.pull"
      releaseLabelKey="notifications.refresh.release"
      refreshingLabelKey="notifications.refresh.refreshing"
    />
  )
}
